import React from 'react';
import {spacing} from 'styles/globals';

import {
	ButtonField,
	TextField,
	SwitchField,
	SelectField,
} from 'components/Fields';
import Panel from 'components/Panel';

function OptionPanel({indented, ...otherProps}) {
	return (
		<Panel
			size="l"
			style={indented ? {marginLeft: spacing.m} : null}
			{...otherProps}
		/>
	);
}

export function Option({
	type = 'text',
	value = '',
	id,
	indented,
	placeholder,
	disabled,
	...otherProps
}) {
	if (type === 'button') {
		return (
			<OptionPanel indented={indented}>
				<ButtonField
					{...otherProps}
					id={id}
					selectedValue={value}
					isDisabled={disabled}
				/>
			</OptionPanel>
		);
	}

	if (type === 'select') {
		return (
			<OptionPanel indented={indented}>
				<SelectField
					{...otherProps}
					id={id}
					selectedValue={value}
					disabled={disabled}
				/>
			</OptionPanel>
		);
	}

	if (type === 'switch') {
		return (
			<OptionPanel indented={indented}>
				<SwitchField
					{...otherProps}
					id={id}
					value={value}
					disabled={disabled}
				/>
			</OptionPanel>
		);
	}

	return (
		<OptionPanel indented={indented}>
			<TextField
				{...otherProps}
				key={value}
				id={id}
				type={type}
				initialValue={value}
				placeholder={placeholder}
				disabled={disabled}
			/>
		</OptionPanel>
	);
}
